import {HFormStructure} from "../../ui/types";

export const modalStructure: HFormStructure = [
  'name'
]
